import { Component, OnInit, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { ISaveCreditCardResponse, ISaveCreditCard, ICreditCardCvc, ICreditCard } from '../../services/credit-card.service';
import { ModalController } from '@ionic/angular';
import { AddCreditCardModalComponent } from '../../modals/add-credit-card-modal/add-credit-card-modal.component';
import { CreditCardListComponent } from '../credit-card-list/credit-card-list.component';

@Component({
    selector: 'account-credit-card-checkout',
    templateUrl: './credit-card-checkout.component.html',
    styleUrls: ['./credit-card-checkout.component.scss'],
    standalone: false
})
export class CreditCardCheckoutComponent implements OnInit {
  @Input() submitted: boolean;
  @Input() recentAddedCard: ISaveCreditCard;
  @Input() storeId: string;
  @Output() onCardSelected: EventEmitter<ICreditCardCvc> = new EventEmitter<ICreditCardCvc>();

  @ViewChild(CreditCardListComponent, { static: true }) creditCardList: CreditCardListComponent;

  constructor(private modalCtrl: ModalController) {

  }

  ngOnInit() {
  }

  onCreditCardSelected(card: ICreditCardCvc) {
    this.onCardSelected.emit(card);
  }

  async addCardClicked() {
    const modal = await this.modalCtrl.create({
      component: AddCreditCardModalComponent,
      componentProps: {
        storeId: this.storeId
      }
    });

    modal.onDidDismiss()
      .then((event) => {
        if (event.data) {
          this.creditCardList.loadSavedCards(event.data);
        }
      });

    await modal.present();
  }
}
